(function () {
  function safeJSON(el) {
    try { return JSON.parse(el.textContent || "{}"); } catch (e) { return {}; }
  }

  function findSelectedVariantId() {
    const idInput = document.querySelector('form[action*="/cart/add"] input[name="id"]');
    const val = idInput && idInput.value;
    return val ? Number(val) : null;
  }

  function applyVariantData(root, dataById, variantId) {
    if (!variantId || !dataById[variantId]) return;

    const v = dataById[variantId];

    root.querySelectorAll("[data-mf-val]").forEach((cell) => {
      const key = cell.getAttribute("data-mf-val");
      const value =
        (v[key] !== undefined && v[key] !== null && String(v[key]).trim() !== "")
          ? v[key]
          : "-";
      cell.textContent = value;
    });
  }

  function initOne(root) {
    const hasMultiple = root.getAttribute("data-has-multiple-variants") === "true";
    if (!hasMultiple) return; // ✅ Single/no variant → table already uses product metafields in Liquid

    const jsonEl = root.querySelector("[data-variant-mf-json]");
    if (!jsonEl) return;

    const json = safeJSON(jsonEl);
    const variants = Array.isArray(json.variants) ? json.variants : [];

    const dataById = {};
    variants.forEach((v) => {
      if (v && v.id) dataById[Number(v.id)] = v;
    });

    // initial
    applyVariantData(root, dataById, findSelectedVariantId());

    // Listen to changes
    document.addEventListener("change", (e) => {
      const t = e.target;
      if (!t) return;

      if (t.closest('form[action*="/cart/add"]') || t.closest("variant-selects") || t.closest("variant-radios")) {
        applyVariantData(root, dataById, findSelectedVariantId());
      }
    });

    // Watch hidden input value changes
    const idInput = document.querySelector('form[action*="/cart/add"] input[name="id"]');
    if (idInput) {
      let last = idInput.value;
      setInterval(() => {
        if (idInput.value !== last) {
          last = idInput.value;
          applyVariantData(root, dataById, findSelectedVariantId());
        }
      }, 250);
    }
  }

  document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll("[data-variant-mf-table]").forEach(initOne);
  });
})();